module.exports = __webpack_public_path__ + "img/img-60.8c192b30.png";